import { render, staticRenderFns } from "./TheCreateProfileSelection.vue?vue&type=template&id=315ea79d"
import script from "./TheCreateProfileSelection.vue?vue&type=script&lang=js"
export * from "./TheCreateProfileSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports